import {VideoUploadModalWrapper} from '@features/video-upload/components/video-upload-modal-wrapper'
import {ModalBody, ModalFooter} from '@components/ui/modal-atoms'
import {Button} from '@components/ui/button'
import {useTranslation} from '@/translations/i18n.tsx'
import {VideoCard} from '@features/video-upload/components/video-card'
import {useVideoUpload} from '@features/video-upload/store.ts'
import {useEffect, useState} from 'react'
import {Spinner} from '@components/ui/spinner'
import {errorHandler, raise} from '@utilities/helpers.ts'
import {httpConfirmUploadMedia, httpUploadMedia} from '@features/video-upload/http/videoUpload.http.ts'
import {ProgressBar} from '@components/ui/progress-bar'

export const UploadingStep = () => {
    const {t} = useTranslation()
    const assignmentId = useVideoUpload(store => store.assignmentId)
    const dropzoneFile = useVideoUpload(store => store.dropzoneFile)
    const setDropzoneFile = useVideoUpload(store => store.setDropzoneFile)
    const file = useVideoUpload(store => store.file)
    const setStep = useVideoUpload(store => store.setStep)
    const linkMediaToUpload = useVideoUpload(store => store.linkMediaToUpload)
    const setLinkMediaToUpload = useVideoUpload(store => store.setLinkMediaToUpload)
    const [progressBarValue, setProgressBarValue] = useState(0)

    const uploadMedia = async () => {
        try {
            await httpUploadMedia({
                url: linkMediaToUpload ?? raise('linkMediaToUpload is nullish'),
                payload: dropzoneFile ?? raise('dropzoneFile is nullish'),
                onUploadProgress: progressEvent => {
                    progressEvent.total
                        ? setProgressBarValue(Math.round((progressEvent.loaded * 100) / progressEvent.total))
                        : setProgressBarValue(100)
                }
            })
            await httpConfirmUploadMedia({
                urlParams: {
                    assignmentId: assignmentId ?? raise('assignmentId is nullish'),
                    mediaId: file?.id ?? raise('mediaId is nullish')
                }
            })
            setDropzoneFile(null)
            setLinkMediaToUpload(null)
            setStep('uploaded')
        } catch (error) {
            errorHandler(error)
        }
    }

    useEffect(() => {
        /*It may throw errors if the React strict mode is enabled because it triggers it twice*/
        void uploadMedia()
    }, [])

    return (
        <VideoUploadModalWrapper>
            <ModalBody>
                <ProgressBar value={progressBarValue} />
                <VideoCard isLoading fileName={dropzoneFile?.name} fileSize={dropzoneFile?.size} />
            </ModalBody>
            <ModalFooter>
                <Button className="w-full" disabled>
                    {t('admin:upload')}
                    <Spinner />
                </Button>
            </ModalFooter>
        </VideoUploadModalWrapper>
    )
}
